<div class="error-server-container">
    <div class="information-container">
        <p class="close"><img src="./assets/logos/close.svg" (click)="close()" alt=""></p>
        <div class="alert"><img src="./assets/temporals/warning.png" alt=""></div>
        <div class="text-information">{{message}}</div>
    </div>
    <div class="oval">
        <div class="oval-background"></div>
        <img class="think-boy" src="./assets/temporals/thinkBoy.png" alt="">
    </div>
    <div class="button-container">
        <button id="closeButton" (click)="close()" type="submit">{{ 'TERMS.ERRORS.REINTENTAR' | translate }}</button>
    </div>
</div>